"use client"

import { useSearchContext } from "@/lib/hooks/searchContext/searchStore";
import { useParams } from "next/navigation";
import { useEffect } from "react";

export default function SearchDrawerHashListener() {
    const params = useParams();
    const searchContext = useSearchContext();

    useEffect(() => {
      const hash = window.location.hash;

      if (hash == "#open-search-drawer") {
        searchContext.setIsOpen(true)
      }
    }, [params]);

    return null
}